<template>
  <b-modal
    :id="`subscription-payment-${subscription.id}`"
    :modal-class="'default-modal'"
    :hide-footer="true"
    ref="paymentSubscription"
    @hidden="hide"
    @shown="shown"
  >
    <template v-slot:modal-title>
      Forma de pagamento da assinatura
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div
        class="text-center"
        v-if="loader"
      >
        <Loader
          color="color2"
          size="big"
        />
      </div>
      <div v-else>
        <!-- STEP SELECT -->
        <div
          class="text-center font-size-small payment-method-selection"
          v-if="step === 'select'"
        >
          <p class="text-center font-size-small">Escolha um método de pagamento para a assinatura</p>
          <ul class="d-flex flex-column align-items-center default-form col-md-8 mx-md-auto">
            <li
              class="w-100"
              v-for="(method, index) in paymentMethods"
              :key="index"
            >
              <div class="styled-radio-as-input d-flex h-100">
                <input
                  type="radio"
                  :value="method"
                  v-model="form.payment_method"
                  class="d-none"
                  :id="method"
                />
                <label
                  class="w-100 d-flex align-items-center"
                  :for="method"
                >
                  <img :src="`/images/icons/${method}.png`" alt="" />
                  {{ method | formatPaymentMethod }}
                </label>
              </div>
            </li>
          </ul>
          <!-- ACTIONS -->
          <div class="mt-3">
            <Button
              class="btn-primary btn-sm"
              @click="submit"
              :disabled="$v.$invalid"
              :loading="submitting"
              v-if="form.payment_method !== 'credit_card'"
            >
              Salvar
            </Button>
            <Button
              class="btn-primary btn-sm"
              @click="changeStep('credit-card')"
              v-if="form.payment_method === 'credit_card'"
            >
              Avançar
            </Button>
          </div> <!-- END ACTIONS -->
        </div>
        <!-- END STEP SELECT -->
        <!-- CREDIT CARD SELECT -->
        <div
          class="text-center font-size-small credit-card-selection"
          v-if="step === 'credit-card'"
        >
          <template v-if="!creditCardCreation">
            <!-- CARD LIST -->
            <template
              v-if="cards.length > 0"
            >
              <div class="d-flex flex-wrap">
                <div
                  class="col-12 mb-3"
                  v-for="card in cards"
                  :key="card.id"
                >
                  <label>
                    <input type="radio" :value="card.id" v-model="form.card_id" class="d-none" />
                    <CreditCardCard
                      class="cursor-pointer"
                      :card="card"
                      size="small"
                    />
                  </label>
                </div>
              </div>
            </template> <!-- END CARD LIST -->
            <!-- NO CARDS -->
            <template v-else>
              <p>Não foram encontrados cartões de crédito cadastrados</p>
            </template> <!-- END NO CARDS -->
            <div class="">
              <Button
                class="btn-outline-color2 btn-sm"
                @click="creditCardCreation = true"
              >
                Criar cartão
              </Button>
              <Button
                class="btn-primary btn-sm ml-2"
                @click="submit"
                :loading="submitting"
                :disabled="!form.card_id"
              >
                Salvar
              </Button>
            </div>
          </template>
          <!-- CREDIT CARD CREATION FORM -->
          <template
            v-else
          >
            <p class="mb-2">Preencha os dados do cartão</p>
            <CreditCardCreationForm
              @credit-card-created="parseCreatedCard"
            />
          </template> <!-- END CREDIT CARD CREATION FORM -->
        </div> <!-- END CREDIT CARD SELECT -->
      </div>
    </template>
  </b-modal>
</template>

<script>

import CreditCardsService from '@/modules/credit-cards/services/credit-cards-service'
import GroupsService from '@/modules/groups/services/groups-service'
import ProductsService from '@/modules/products/services/products-service'
import SubscriptionsService from '@/modules/subscriptions/services/subscriptions-service'
import { required } from 'vuelidate/lib/validators'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import CreditCardCard from '@/components/credit-cards/CreditCardCard'
import CreditCardCreationForm from '@/components/credit-cards/CreditCardCreationForm'
import Loader from '@/components/common/Loader/Loader'
// import BaseIcon from '@/components/common/Icon/BaseIcon'
import Button from '@/components/common/Button/Button'
// import WarningIcon from '@/components/common/Icon/WarningIcon'

export default {
  name: 'SubscriptionPaymentMethodModal',
  props: ['subscription'],
  components: {
    AlertWraper,
    CreditCardCard,
    CreditCardCreationForm,
    // BaseIcon,
    Button,
    Loader
    // WarningIcon
  },
  data () {
    return {
      errors: null,
      loader: false,
      submitting: false,
      product: null,
      step: 'select',
      cards: [],
      creditCardCreation: false,
      form: {
        payment_method: '',
        card_id: ''
      }
    }
  },
  validations () {
    const validation = {
      form: {
        payment_method: { required }
      }
    }

    if (this.form.payment_method === 'credit_card') validation.form.card_id = { required }

    return validation
  },
  computed: {
    paymentMethods () {
      if (!this.product || !this.product.available_payment_methods) return []
      return this.product.available_payment_methods
    }
  },
  methods: {
    shown () {
      this.form.payment_method = this.subscription.payment_method
      // Get product
      if (this.subscription.type === 'group') this.getGroup()
      else if (this.subscription.type === 'scriv_pro') this.getProduct()
    },
    hide () {
      this.reset()
    },
    reset () {
      this.step = 'select'
      this.form.payment_method = ''
      this.form.card_id = ''
      this.cards = []
      this.errors = null
      this.product = false
      this.submitting = false
    },
    async getGroup () {
      this.loader = true
      try {
        const group = await GroupsService.getGroup(this.subscription.entity.slug)
        this.product = group
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    async getProduct () {
      this.loader = true
      try {
        const product = await ProductsService.getProduct(this.subscription.entity.id)
        this.product = product
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    changeStep (step) {
      this.step = step

      if (step === 'credit-card') {
        this.getCreditCards()
      }
    },
    async submit () {
      this.submitting = true
      this.errors = null
      try {
        const subscription = await SubscriptionsService.updateSubscription(this.subscription.id, this.form)
        this.$emit('payment-method-changed', subscription)
        this.$bvModal.hide(`subscription-payment-${subscription.id}`)
        const notification = {
          notification: {
            type: 'success',
            content: 'Forma de pagamento alterada'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.submitting = false
    },
    async getCreditCards () {
      this.loader = true
      this.errors = null
      try {
        const cards = await CreditCardsService.getCreditCards()
        this.cards = cards
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    parseCreatedCard (card) {
      this.creditCardCreation = false
      this.getCreditCards()
    }
  }
}
</script>

<style lang="scss" scoped>

.credit-card-selection {
  ::v-deep {
    input:checked + .credit-card-wrap {
      border: 1px solid $color2;
    }
  }
}

.payment-method-selection {
  img {
    width: 40px;
    margin-right: 10px;
  }
}

</style>
